const rawClinicCodeSystem = (process.env.VUE_APP_CLINIC_CODE_SYSTEM || 'ICPC').toUpperCase()
const allowedValues = ['ICPC', 'ICD10', 'BOTH']
const clinicCodeSystem = allowedValues.includes(rawClinicCodeSystem) ? rawClinicCodeSystem : 'ICPC'

export const useICPC = clinicCodeSystem === 'ICPC' || clinicCodeSystem === 'BOTH'
export const useICD10 = clinicCodeSystem === 'ICD10' || clinicCodeSystem === 'BOTH'
export const activeClinicCodeSystem = clinicCodeSystem
